<div class="unauth-right-header">
  <img src="assets/images/complydome-logo.png" class="unauth-mobile-logo" alt="ComplyDome">
  <a routerLink="/login">← Back to Sign In</a>
</div>

<main class="unauth-form-area">
  <div class="unauth-card">
    <h2>Set New Password</h2>

    <div class="unauth-security-badge">
      <span class="unauth-security-dot"></span>
      Secure Reset
    </div>

    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" novalidate>

      <div class="unauth-form-group"
        [class.has-error]="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched">
        <label for="newPassword">New Password</label>
        <div class="unauth-input-wrapper">
          <input
            type="password"
            id="newPassword"
            formControlName="newPassword"
            required
            placeholder="••••••••"
            aria-label="New Password">
        </div>
        <div class="unauth-error-msg" *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched">
          <i class="fas fa-info-circle"></i>
          <span *ngIf="passwordForm.get('newPassword')?.errors?.['required']">Password is required.</span>
          <span *ngIf="passwordForm.get('newPassword')?.errors?.['minlength']">Password must be at least 8 characters.</span>
        </div>
      </div>

      <div class="unauth-form-group"
        [class.has-error]="(passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched) || (passwordForm.errors?.['passwordsDoNotMatch'] && passwordForm.get('confirmPassword')?.touched)">
        <label for="confirmPassword">Confirm Password</label>
        <div class="unauth-input-wrapper">
          <input
            type="password"
            id="confirmPassword"
            formControlName="confirmPassword"
            required
            placeholder="••••••••"
            aria-label="Confirm Password">
        </div>
        <div class="unauth-error-msg" *ngIf="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched">
          <i class="fas fa-info-circle"></i>
          <span>Password confirmation is required.</span>
        </div>
        <div class="unauth-error-msg" *ngIf="passwordForm.errors?.['passwordsDoNotMatch'] && passwordForm.get('confirmPassword')?.touched">
          <i class="fas fa-info-circle"></i>
          <span>Passwords do not match.</span>
        </div>
      </div>

      <button
        type="submit"
        class="unauth-btn-primary"
        [disabled]="!passwordForm.valid">
        Set Password
      </button>

      <div class="unauth-forgot">
        <a routerLink="/login">Back to Sign In</a>
      </div>

    </form>
  </div>
</main>
